import { FetchingActionType, PersistValueActionType } from 'features/Persist/actionTypes';
import { PersistValueReducer } from 'features/Persist/reducerTypes';
import { TimesheetsConfigResponse } from 'services/tenantManagementService';
import { TIMESHEETS_GENERAL_CONFIGURATION_FETCHING, TIMESHEETS_GENERAL_CONFIGURATION_SET } from './action';

export const timesheetsGeneralConfigurationReducer = (state = new PersistValueReducer<TimesheetsConfigResponse>(), action: PersistValueActionType<TimesheetsConfigResponse> | FetchingActionType): PersistValueReducer<TimesheetsConfigResponse> => {
	switch (action.type) {
		case TIMESHEETS_GENERAL_CONFIGURATION_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case TIMESHEETS_GENERAL_CONFIGURATION_SET:
			const { value } = action as PersistValueActionType<TimesheetsConfigResponse>;

			return {
				value,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
